export default {
  ASSESMENT: 1,
  EDUCATION: 3,
  ENFORCEMENT: 2,
  LANDSCAPE: 4,
};
